import { Controller } from "@hotwired/stimulus"

const errorMessage = `<strong><span aria-hidden="true" class="far fa-exclamation-triangle"></span>
                    Your registration failed.</strong>
                    <p>Please try again or
                    <a href="https://app.livestorm.co/hunterio/hunter-live-demo">register from the event page</a></p>`

const alreadyRegisteredMessage = `<strong><span aria-hidden="true" class="far fa-check"></span>
                                You are already registered for this event.</strong>
                                <p>We will send you a link by email before the event starts.</p>`

export default class extends Controller {
  static targets = ["submitBtn", "form", "formContainer", "sessionTemplate", "sessionsList", "feedbackMessage"]
  static values = { livestormToken: String, eventId: String }

  connect() {
    this._getSessions()
  }

  registerUser(e) {
    e.preventDefault()

    const _this = this
    const form = this.formTarget
    const formData = new FormData(form)
    const fields = []
    const sessionId = document.querySelector('input[name="registration_session"]:checked').value
    const feedbackMessage = _this.feedbackMessageTarget

    formData.forEach(function (value, key) {
      if (
        key !== "registration_session" &&
        key !== "livestorm_consent" &&
        key !== "what_are_you_mostly_interested_in"
      ) {
        const element = {}
        element.id = key
        element.value = value

        fields.push(element)
      }
    })

    // For "What are you mostly interested in?", we are forced to apply a different logic
    const element = {}
    element.id = "what_are_you_mostly_interested_in"
    element.value = []

    $("input:checkbox[name='what_are_you_mostly_interested_in']:checked").each(function () {
      element.value.push($(this).val())
    })

    fields.push(element)

    const fieldsJson = JSON.stringify(fields)
    const options = {
      method: "POST",
      headers: {
        Accept: "application/vnd.api+json",
        "Content-Type": "application/vnd.api+json",
        Authorization: `${this.livestormTokenValue}`,
      },
      body: `{"data":{"type":"people","attributes":{"fields": ${fieldsJson}, "referrer": "hunter.io/webinars" }}}`,
    }

    fetch(`https://api.livestorm.co/v1/sessions/${sessionId}/people`, options)
      .then(function (response) {
        const statusCode = response.status

        if (response.ok) {
          _this.formContainerTarget.classList.add("is-registered")
          feedbackMessage.classList.add("d-none")
        } else if (statusCode === 409) {
          _this._displayMessage(feedbackMessage, "alert-info", alreadyRegisteredMessage)
          App.enableForm()
        } else {
          _this._displayMessage(feedbackMessage, "alert-danger", errorMessage)
          App.enableForm()
        }
      })
      .catch(function (err) {
        _this._displayMessage(feedbackMessage, "alert-danger", errorMessage)
        App.enableForm()
        console.error(err)
      })
  }

  hideConfirmation() {
    const form = this.formTarget

    form.reset()
    this.formContainerTarget.classList.remove("is-registered")
    App.enableForm()
  }

  // Get and display the two upcoming sessions for the live webinar
  _getSessions() {
    import("moment").then(({ default: moment }) => {
      const options = {
        method: "GET",
        headers: {
          Accept: "application/vnd.api+json",
          Authorization: `${this.livestormTokenValue}`,
        },
      }

      fetch(`https://api.livestorm.co/v1/events/${this.eventIdValue}/sessions?filter[status]=upcoming`, options)
        .then((response) => response.json())
        .then((response) => {
          // Livestorm sends the events from farthest to nearest
          // so we reverse the Array and keep the two upcoming sessions.
          const sessions = response.data.reverse().slice(0, 2)

          // Create the input radio for each session
          if (sessions.length >= 1) {
            sessions.forEach((element) => {
              let template = document.importNode(this.sessionTemplateTarget.content, true)
              let sessionLabel = template.getElementById("session-label")
              let sessionRadio = template.getElementById("session-input")
              let sessionDate = template.getElementById("session-date")
              const startDate = moment
                .unix(element.attributes["estimated_started_at"])
                .format("dddd, MMMM Do YYYY - h:mm A")

              sessionLabel.setAttribute("for", `registration-session-${element.id}}`)
              sessionLabel.removeAttribute("id")

              sessionRadio.setAttribute("value", element.id)
              sessionRadio.setAttribute("id", `registration-session-${element.id}}`)

              sessionDate.removeAttribute("id")
              sessionDate.innerText = startDate

              this.sessionsListTarget.appendChild(template)
            })
          } else {
            this.submitBtnTarget.setAttribute("disabled", "true")
            this.sessionsListTarget.innerHTML = `<div class="no-sessions"><strong>No upcoming sessions.</strong>
                                                <br />More sessions will be scheduled soon. Come back again to register!</div>`
          }
        })
        .catch(function (err) {
          console.error(err)
          this.submitBtnTarget.setAttribute("disabled", "true")
          this.sessionsListTarget.innterHTML = `<div class="no-sessions black"><strong>Something went wrong while retrieving upcoming sessions.</strong>.
                                                Please try again or <a href="https://app.livestorm.co/hunterio/hunter-live-demo">register from the event page</a></div>`
        })
    })
  }

  // Display feedback message
  _displayMessage(element, type, message) {
    element.className = ""
    element.classList.add("alert")
    element.classList.add(type)
    element.innerHTML = message
  }
}
